<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('router.AccountDetail.title')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-empty v-if="list.length === 0" :description="$t('common.emptyData')" />
          <div v-else class="item_list" v-for="(v,key) in list" :key="key">
            <div class="topInfo">
              <span class="type-badge" :class="'type-' + v.kind">{{ typeLabel(v.kind) }}</span>
              <span class="amount" :class="v.kind === 'recharge' ? 'plus' : 'minus'">
                {{ v.kind === 'recharge' ? '+' : '-' }}{{ v.money }}
              </span>
            </div>
            <div class="desc" v-if="v.kind === 'game'">{{ v.lottery_name }}</div>
            <div class="desc" v-if="v.kind === 'recharge' && v.coin">{{ v.coin.toUpperCase() }}</div>
            <div class="time">
              <span :class="v.statusClass">{{ v.statusText }}</span>
              <span class="time-text">{{ v.time }}</span>
            </div>
          </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: []
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    typeLabel(kind){
      return this.$t('mine.accountDetail.kind.' + kind);
    },
    onRefresh(){
      this.loadAll();
    },
    // 三路并行拉齐后按时间倒序合并。任一失败不拖垮整页（对应路返回空）。
    loadAll(){
      Promise.all([
        this.fetch('recharge_my_list').then(rows => rows.map(r => ({
          kind: 'recharge',
          money: r.money,
          time: this.fmt(r.create_time),
          status: r.status,
          statusText: this.statusText('recharge', r.status),
          statusClass: r.status === 2 ? 'ok' : (r.status === 3 ? 'fail' : 'wait'),
          coin: r.coin || ''
        }))).catch(() => []),
        this.fetch('user_get_withdraw_list').then(rows => rows.map(r => ({
          kind: 'withdraw',
          money: r.money,
          time: this.fmt(r.create_time),
          status: r.status,
          statusText: r.status_text || this.statusText('withdraw', r.status),
          statusClass: r.status === 2 ? 'ok' : (r.status === 3 ? 'fail' : 'wait')
        }))).catch(() => []),
        this.fetch('user_get_game_list').then(rows => rows.map(r => ({
          kind: 'game',
          money: r.money,
          time: this.fmt(r.create_time),
          status: r.status,
          statusText: r.status_text || '',
          statusClass: r.status === 1 ? 'ok' : 'wait',
          lottery_name: r.lottery ? r.lottery.name : ''
        }))).catch(() => [])
      ]).then(arrays => {
        // game 的 status：后端 0=结算中 1=已结算（见 getUserGameList 的 status_text）；
        // recharge/withdraw：1待审 2成功 3驳回 —— 统一时序键统一用原始 create_time
        this.list = [].concat.apply([], arrays).sort((a, b) => b.rawTime - a.rawTime);
        this.isLoading = false;
      });
    },
    fetch(url){
      return this.$http({ method: 'get', url: url }).then(res => {
        if(res.code === 200 && Array.isArray(res.data)){
          return res.data;
        }
        if(res.code === 401){
          this.$toast(res.msg);
        }
        return [];
      });
    },
    statusText(kind, status){
      const map = {
        recharge: {1: 'pending', 2: 'done', 3: 'rejected'},
        withdraw: {1: 'pending', 2: 'done', 3: 'rejected'}
      };
      const k = (map[kind] || {})[status];
      return k ? this.$t('recharge.' + k) : '';
    },
    fmt(ts){
      ts = parseInt(ts, 10);
      if(!ts){ return ''; }
      const d = new Date(ts * 1000);
      const p = n => (n < 10 ? '0' + n : '' + n);
      return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
        + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'});
    }else {
      this.loadAll();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.container .main{
  padding: 20px;
}
.item_list{
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
}
.topInfo{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.type-badge{
  font-size: 24px;
  padding: 4px 16px;
  border-radius: 8px;
  color: #fff;
}
.type-recharge{ background: #07c160; }
.type-withdraw{ background: #ee0a24; }
.type-game{ background: #7e5678; }
.amount{
  font-size: 34px;
  font-weight: bold;
}
.amount.plus{ color: #07c160; }
.amount.minus{ color: #333; }
.desc{
  margin-top: 12px;
  font-size: 26px;
  color: #666;
}
.time{
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  color: #999;
}
.time .ok{ color: #07c160; }
.time .fail{ color: #ee0a24; }
.time .wait{ color: #ff976a; }
.time-text{ color: #999; }
</style>
